import React from 'react';
import styles from './CartCheckoutAdpForm.module.scss';
import LicenseMessage from '../../Messages/LicenseMessage/LicenseMessage';
import SingleAssetSize from '../../AssetSizes/SingleAssetSize';
import VideoTemplate from '../../VideoTemplate/VideoTemplate.tsx';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex.ts';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import AssetOptions from '../../AssetOptions/AssetOptions';

const CartCheckoutAdpForm = () => {
  const { selectedOption } = useSelectedIndex();
  const {
    asset: { isVideoTemplate },
  } = useAsset();

  const assetInfo = isVideoTemplate() ? <VideoTemplate /> : <SingleAssetSize />;
  return (
    <div className={styles.container}>
      <AssetOptions />
      <LicenseMessage />
      {selectedOption?.type !== 'customlicense' && assetInfo}
    </div>
  );
};

export default CartCheckoutAdpForm;
